import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';

export default function SimulatorPage() {
  const [route, setRoute] = useState([]);
  const [index, setIndex] = useState(null);
  const startTime = useRef(Date.now());

  useEffect(() => {
    fetch('/route.gpx')
      .then(res => res.text())
      .then(xmlText => {
        const parser = new DOMParser();
        const gpx = parser.parseFromString(xmlText, 'application/xml');
        const trkpts = Array.from(gpx.querySelectorAll('trkpt')).map(pt =>
          L.latLng(parseFloat(pt.getAttribute('lat')), parseFloat(pt.getAttribute('lon')))
        );

        if (trkpts.length) {
          setRoute(trkpts);
          const min = Math.floor(trkpts.length * 0.25);
          const max = Math.floor(trkpts.length * 0.75);
          const randomStart = Math.floor(Math.random() * (max - min) + min);
          setIndex(randomStart);
        }
      });
  }, []);

  useEffect(() => {
    if (!route.length || index == null) return;

    const interval = setInterval(() => {
      const pt = route[index];
      if (!pt) return;

      const secondsSinceStart = (Date.now() - startTime.current) / 1000;
      const wave = Math.sin((secondsSinceStart / 900) * Math.PI * 2); // 3 min period
      const speedKmh = 22.5 + 4 * wave; // ~20–25 km/h smooth

      const spoofed = {
        id: 'simulator',
        timestamp: Math.floor(Date.now() / 1000),
        lat: pt.lat + (Math.random() - 0.5) * 0.0001,
        lon: pt.lng + (Math.random() - 0.5) * 0.0001,
        speed: speedKmh, // already in km/h
        bearing: Math.floor(Math.random() * 360),
        altitude: 42 + Math.random() * 2,
        accuracy: 5 + Math.random() * 3,
        batt: 0.80
      };

      const query = new URLSearchParams(spoofed).toString();
      fetch(`https://nm.digitalestudent.nl/api/tdt/update?${query}`)
        .then(r => r.text())
        .then(console.log);

      setIndex(i => (i + 1) % route.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [route, index]);

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h2>Simulator Running</h2>
      <p>Sending spoofed data every 10 seconds. Current index: {index ?? '…'}</p>
    </div>
  );
}
